module.exports = __webpack_public_path__ + "fonts/worksans-bold.6ab783b.woff2";